import router from "@/router";

export function registerToPendingCycle(cycleStore) {
  const storeCycle = async (cycle, forceOpenModal) => {
    let date = cycle.createdAt ? cycle.createdAt : new Date();
    await cycleStore.setCycleToRegister({
      ...cycle,
      date: date,
      forceOpenModal: forceOpenModal,
    });
  };

  const lastPendingCycle = async (dbCycleStored) => {
    // get last pendingCycle between localStorage and back end
    const localStorageCycle = cycleStore.getCycleToRegister;
    if (!localStorageCycle && !dbCycleStored) {
      return;
    }

    if (!localStorageCycle) {
      const cycle = await cycleStore.retrieveCycle(dbCycleStored.cycle);
      return await storeCycle(cycle);
    } else if (!dbCycleStored) {
      return await storeCycle(localStorageCycle);
    }

    const localStorageCycleStoreDate = new Date(await localStorageCycle.date);
    if (dbCycleStored) {
      const dbStorageCycleStoreDate = new Date(dbCycleStored.createdAt);
      if (dbStorageCycleStoreDate.getTime() < localStorageCycleStoreDate.getTime()) {
        const cycle = await cycleStore.retrieveCycle(dbCycleStored.cycle);
        return await storeCycle(cycle);
      }
    }
    return await storeCycle(localStorageCycle);
  };

  const loginAndRegister = async (cycle) => {
    await storeCycle(cycle);
    await router.push({ name: "candidate-dashboard" });
  };

  const createAccountAndRegister = async (cycle) => {
    await storeCycle(cycle);
    await router.push({ name: "publicRegister" });
  };

  return {
    createAccountAndRegister,
    loginAndRegister,
    lastPendingCycle,
    storeCycle,
  };
}
